import get from 'lodash.get';
import { btnLarge, btnMedium } from '../../fonts';
const buttonColors = {
  primary: {
    50: '#FAFAFA',
    200: '#CAD9F2',
    400: '#6591CA',
    500: '#0A4A8D',
    600: '#223044'
  },
  gold: {
    50: '#FAFAFA',
    200: '#ECE7D6',
    500: '#A18732',
    600: '#C7B784'
  },
  secondary: {
    50: '#FAFAFA',
    200: '#B3E2FB',
    500: '#499CC9',
    600: '#77C1E9'
  },
  tertiary: {
    50: '#FAFAFA',
    200: '#BDF9FF',
    500: '#6ED8FF',
    600: '#8EECFF'
  },
  lightGray: {
    50: '#FAFAFA',
    200: '#FAFAFA',
    300: '#757575',
    500: '#BDBDBD',
    600: '#EEEEEE',
    800: '#E0E0E0'
  },
  darkGray: {
    50: '#FAFAFA',
    200: '#9E9E9E',
    500: '#212121',
    600: '#616161'
  },
  success: {
    50: '#FAFAFA',
    200: '#D9EFE9',
    500: '#03906A',
    600: '#005F44'
  },
  error: {
    50: '#FAFAFA',
    200: '#FBE1E1',
    500: '#CC3736',
    600: '#841E1D'
  }
};
const Button = {
  baseStyle: {
    borderRadius: 'sm',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    _web: {
      _disabled: {
        cursor: 'not-allowed'
      },
      _loading: {
        cursor: 'not-allowed'
      },
      cursor: 'pointer',
      userSelect: 'none'
    },
    _stack: {
      space: '2.5'
    }
  },
  variants: {
    solid: _ref => {
      let {
        colorScheme
      } = _ref;
      const colors = get(buttonColors, [colorScheme], buttonColors.primary);
      return {
        _text: {
          color: 'muted.50',
          textTransform: 'uppercase'
        },
        _icon: {
          fill: `${colors[50]}`
        },
        _spinner: {
          color: 'muted.50'
        },
        bg: `${colors[500]}`,
        _hover: {
          bg: `${colors[600]}`
        },
        _pressed: {
          bg: `${colors[600]}`
        },
        _dark: {
          bg: `${colors[500]}`,
          _hover: {
            bg: 'web.500'
          },
          _pressed: {
            bg: 'web.500'
          }
        },
        _disabled: {
          bg: buttonColors.lightGray[800],
          opacity: 90,
          _text: {
            color: buttonColors.lightGray[300],
            borderColor: buttonColors.lightGray[300]
          },
          _icon: {
            fill: buttonColors.lightGray[300]
          }
        }
      };
    },
    outline: _ref2 => {
      let {
        colorScheme
      } = _ref2;
      const colors = get(buttonColors, [colorScheme], buttonColors.primary);
      return {
        borderWidth: '1px',
        borderColor: `${colors[400]}`,
        _text: {
          color: `${colors[500]}`,
          textTransform: 'uppercase'
        },
        _icon: {
          fill: `${colors[500]}`
        },
        _spinner: {
          color: `${colors[500]}`
        },
        _hover: {
          bg: `${colors[200]}`
        },
        _pressed: {
          bg: `${colors[200]}`
        },
        _disabled: {
          borderColor: buttonColors.lightGray[300],
          _text: {
            color: buttonColors.lightGray[300]
          },
          _icon: {
            fill: buttonColors.lightGray[300]
          }
        }
      };
    },
    link: _ref3 => {
      let {
        colorScheme
      } = _ref3;
      const colors = get(buttonColors, [colorScheme], buttonColors.primary);
      return {
        _icon: {
          fill: `${colors[600]}`
        },
        _spinner: {
          color: `${colors[600]}`
        },
        _hover: {
          _text: {
            textDecorationLine: 'none',
            textTransform: 'uppercase'
          }
        },
        _pressed: {
          _text: {
            color: `${colors}.800`,
            textDecorationLine: 'none'
          }
        },
        _text: {
          color: `${colors[600]}`
        },
        _disabled: {
          _text: {
            color: buttonColors.lightGray[300]
          },
          _icon: {
            fill: buttonColors.lightGray[300]
          }
        }
      };
    },
    ghost: _ref4 => {
      let {
        colorScheme
      } = _ref4;
      const colors = get(buttonColors, [colorScheme], buttonColors.primary);
      return {
        _text: {
          color: `${colors[500]}`
        },
        _icon: {
          fill: `${colors[500]}`
        },
        _spinner: {
          color: `${colors[500]}`
        },
        _hover: {
          bg: `${colors[200]}`
        },
        _pressed: {
          bg: `${colors[200]}`
        },
        _disabled: {
          _text: {
            color: buttonColors.lightGray[300]
          },
          _icon: {
            fill: buttonColors.lightGray[300]
          }
        }
      };
    }
  },
  sizes: {
    lg: {
      width: 24.25,
      py: '2',
      px: undefined,
      _text: {
        fontSize: btnLarge.fontSize.base,
        fontWeight: btnLarge.fontWeight.base,
        lineHeight: btnLarge.lineHeight.base
      },
      _icon: {
        size: '4'
      }
    },
    md: {
      width: '22.25',
      py: '1.5',
      px: '4',
      _text: {
        fontSize: btnMedium.fontSize.base
      },
      _icon: {
        size: '4'
      }
    }
  }
};
export { Button };
//# sourceMappingURL=index.js.map